import React, { useContext, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { EmpdContext } from "../../Context";
import DashboardCard from "./DashboardCard";
import parse from 'html-react-parser'

import {
  angleSmallDown,
  comment,
  newspaper,
  refresh,
} from "../../Assets/Images";
import classNames from "classnames";
import Button from "../../Components/Button";
import { RotatingLines } from 'react-loader-spinner';

interface Props {
  className?: string;
}

const useStyles = createUseStyles({
  root: {},
  announcement: {
    padding: 30,
    backgroundColor: "#f7faff",
    "& p": {
      marginTop: 10,
    },
    transition: "all 1s ease",
  },
  announcementInner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    transform: "",
  },
  icon: {
    width: "auto",
    height: 25,
    marginRight: 10,
  },
  announcementHeading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: 0,
    "& h4": {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  announcementBorder: {
    marginBottom: 30,
  },
  announcementOptOut: {
    backgroundColor: "#f6bb6021 !important",
  },
  optOutButton: {
    display: "inline-block",
  },
  announcementMessage: {
    paddingTop: 20,
  },
  "@keyframes fade_in": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  fadeIn: {
    animation: "$fade_in 1.3s ease both",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const AnnouncementsCard = ({ className }: Props) => {
  const { isLoading, updateFields, communicate, setCommunicate, writeFlags, schemaName, demoTable, fetchMessageContent, messagingContent }  = useMyContext()  

  const [activeCard, setActiveCard] = useState(-1);

  useEffect(() => {
  	fetchMessageContent()
  },[])

  const classes = useStyles();

  let providerMotd = undefined
  let providerUpdate = undefined
  let providerLatestNews = undefined

  if( messagingContent && messagingContent.length > 0 ) {
    providerMotd = messagingContent.find((element:any) => {
        return Object.keys(element)[0] === 'provider_message_of_the_day'
    })['provider_message_of_the_day']
    providerUpdate = messagingContent.find((element:any) => {
        return Object.keys(element)[0] === 'provider_update'
    })['provider_update']
    providerLatestNews = messagingContent.find((element:any) => {
        return Object.keys(element)[0] === 'provider_latest'
    })['provider_latest']
  }

  if( providerMotd === undefined || providerUpdate === undefined || providerLatestNews === undefined ) {
  	return <></>
  }

  const ANNOUNCEMENTS = [
    {
      isOptOut: false,
      icon: comment,
      header: providerMotd.header,
      message: parse(providerMotd.content),
	  showMessage: providerMotd.showMessage,
    },
    {
      isOptOut: false,
      icon: refresh,
      header: providerUpdate.header,
      message: parse(providerUpdate.content),
	  showMessage: providerUpdate.showMessage
    },
    {
      isOptOut: false,
      icon: newspaper,
      header: providerLatestNews.header,
      message: parse(providerLatestNews.content),
	  showMessage: providerLatestNews.showMessage,
    },
    {
      isOptOut: true,
      header: "Communications Opt In/Out",
      message: "You are currently recieving commications from the EMPD Team.  Selecting this will unsubscribe you from all future emails from the EMPD Research Network.",
      messageIn: "You are currently NOT receiving communcations from the EMPD Team.  Selecting this subscribe you to all future emails from the EMPD Research Network.",
      button: {
        label: "I do not wish to receive any communications",
        labelIn: "I wish to receive communications",
        onClick: (communicate: boolean, setCommunicate:(value: boolean) => void, writeFlags:(value: any) => void, schemaName: string | undefined, demoTable: string | undefined) => {
  	      setCommunicate(!communicate)
  	  	  writeFlags({[`${schemaName}.${demoTable}.communicate`]: !communicate})
	    },
      },
    },
];

  if( !isLoading ) {
    return (
      <DashboardCard
        title={"Announcements"}
        className={classNames(classes.root, className)}
      >
        {ANNOUNCEMENTS.map((announcement, index) => {
	  	  return (
	  	    (((announcement.hasOwnProperty('showMessage') && announcement.showMessage) || !announcement.hasOwnProperty('showMessage')) && (
        	  <div
	            key={`provider-${announcement.header}`}
  			    className={classNames(classes.announcement, {
    	    	  [classes.announcementBorder]: index < ANNOUNCEMENTS.length - 1,
	    		  [classes.announcementOptOut]: announcement.isOptOut,
			    })}
			    onMouseEnter={() => setActiveCard(index)}
          	    onMouseLeave={() => setActiveCard(-1)}
        	  >
          		<div className={classes.announcementInner}>
            		<div className={classes.announcementHeading}>
              			{announcement.icon && (
                			<img
                  				src={announcement.icon}
                  				alt="icon"
                  				className={classes.icon}
                			/>
              			)}
              			<h4>{announcement.header}</h4>
            		</div>
            		{!announcement.button && (
              			<img
                			src={angleSmallDown}
                			alt="down icon"
                			className={classes.icon}
              			/>
            		)}
          		</div>
          		{(activeCard === index || announcement.isOptOut) && (
            		<p
              			className={classNames(classes.announcementMessage, {
                			[classes.fadeIn]: activeCard === index && !announcement.isOptOut,
              			})}
            		>
              		{announcement.isOptOut ? 
			  			communicate ? 
						announcement.message
						:
						announcement.messageIn 
						: announcement.message}
            		</p>
          		)}

          		{announcement.button && (
            		<Button
              			className={classes.optOutButton}
			              label={announcement.isOptOut ? 
					  	  	communicate ?
	  				  	  	announcement.button.label
						  	:
						  	announcement.button.labelIn
						  	: announcement.button.label
			  			  }
              			  onClick={() => announcement.button.onClick(communicate, setCommunicate, writeFlags, schemaName, demoTable)}
            		/>
          		)}
        	  </div>))
      	    )}
	 	  )}
      </DashboardCard>
    );
  } else {
    return (
      <div className='top-center'>
        <RotatingLines
	      strokeColor="#152E54"
          strokeWidth="3"
          animationDuration="1.0"
          width="48"
          visible={true}
        />
      </div>
	)
  }
};

export default AnnouncementsCard;
